export enum TabsServiceProviderEnum {
    Form = 1,
    History = 2
}


// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-service-provicer.enum.ts